/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixElement extends models.ZabbixElementBase {
    getFixupPrototypeFunction() { return ZabbixElement.fixupPrototype; }

    static newInstance(model: Partial<ZabbixElement>): ZabbixElement {
        let obj = Object.assign(new ZabbixElement(), model);
        ZabbixElement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixElement>): ZabbixElement {
        if (!model) return null;
        return ZabbixElement.newInstance(<ZabbixElement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixElement) {
        if (!obj) return;

        models.ZabbixElement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixElement): boolean {
        if (models.ZabbixElementBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ZabbixElement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Key with respect to Zabbix configuration
     */
    key: string;

    /**
     * Interval for the trigger
     */
    interval: string;

    /**
     * Zabbix classification for the item
     */
    item_type: string;

    /**
     * List of hosts
     */
    hosts: Array<string>;

    /**
     * Enabled or not
     */
    enabled: boolean;

}
